import { render } from "./Inscription.vue?vue&type=template&id=75ab19ea&scoped=true"
import script from "./Inscription.vue?vue&type=script&lang=ts"
export * from "./Inscription.vue?vue&type=script&lang=ts"

import "./Inscription.vue?vue&type=style&index=0&id=75ab19ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75ab19ea"

export default script